import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import useWebSocket, { ReadyState } from "react-use-websocket";

import { WebsocketURL } from "./utils/constants";

import { Agent } from "./pages/Agent/Agent";
import { Driver } from "./pages/Driver/Driver";
import { AuthGate } from "./components/AuthGate";
import Auth from "./authConfigure";
import { DispatchContext } from "./contexts/Context";

export const AppContainer = () => {
  const dispatch = React.useContext(DispatchContext);

  // Only the Agent route ("/") attaches an auth token - the backend uses it
  // to authorize the "agent" websocket action server-side (see
  // lambdas/websocket/connect.js). The Driver route connects immediately,
  // with no token, and stays that way - drivers have no Eagle account.
  const [socketUrl, setSocketUrl] = React.useState(
    window.location.pathname === "/" ? null : WebsocketURL
  );

  React.useEffect(() => {
    if (socketUrl !== null) return;

    let cancelled = false;

    Auth.currentSession()
      .then((session) => {
        if (cancelled) return;
        const idToken = session.getIdToken().getJwtToken();
        setSocketUrl(`${WebsocketURL}?token=${idToken}`);
      })
      .catch(() => {
        // not signed in - AuthGate handles showing the sign-in prompt;
        // connect anonymously in the meantime so the page doesn't hang
        if (!cancelled) setSocketUrl(WebsocketURL);
      });

    return () => {
      cancelled = true;
    };
  }, [socketUrl]);

  const { readyState, getWebSocket } = useWebSocket(socketUrl);

  React.useEffect(() => {
    if (readyState === ReadyState.OPEN) {
      const websocket = getWebSocket();
      dispatch({ type: "WEBSOCKET_CONNECT", payload: websocket });
    } else {
      dispatch({ type: "WEBSOCKET_DISCONNECT" });
    }
  }, [dispatch, readyState, getWebSocket]);

  return (
    <>
      <Router>
        <Switch>
          <Route
            path="/"
            exact
            render={() => (
              <AuthGate>
                <Agent />
              </AuthGate>
            )}
          />
          {/* Public on purpose - this is the link texted to drivers, who have no Eagle account */}
          <Route path="/driver/:code" component={Driver} />
        </Switch>
      </Router>
    </>
  );
};
